export function showNotification(setter) {
  setter(true);
  setTimeout(() => {
    setter(false);
  }, 2000);
}

export function checkWin(correct, wrong, word) {
  let status = '';

  // Check for win
  word.split('').forEach(letter => {
    if (!correct.includes(letter)) {
      status = '';
    }
  });

  // Check for lose
  if (wrong.length === 6) {
    status = 'lose';
  }

  // Check for win condition
  if (status !== 'lose' && word.split('').every(letter => correct.includes(letter))) {
    status = 'win';
  }

  return status;
}
